import React, { useMemo } from 'react';
import { DeviceActionProps } from '@components/Actions/ActionsModal/types';
import ActionTypes from '@utils/deviceActions';
import { useTranslation } from 'react-i18next';

interface WithdrawalOfSuspensionPayloadProps {
  action: ActionTypes.WITHDRAWAL_OF_SUSPENSION;
  devices: {
    msisdn: string;
  }[];
}

const useWithdrawalOfSuspension = (
  devices: {
    msisdn: string;
  }[],
): DeviceActionProps => {
  const { t } = useTranslation('actions-modal');

  const infoMessage = useMemo(
    () => (
      <>
        <p style={{ margin: 0 }}>{t('suspension-withdrawal.info-time')}</p>
        <span style={{ fontWeight: 'bold' }}>
          {t('suspension-withdrawal.withdrawal-info-warning')}
        </span>
      </>
    ),
    [t],
  );

  const payloadToSend = useMemo(
    (): WithdrawalOfSuspensionPayloadProps => ({
      action: ActionTypes.WITHDRAWAL_OF_SUSPENSION,
      devices,
    }),
    [devices],
  );

  return {
    steps: [],
    payloadToSend,
    infoMessage,
  };
};

export default useWithdrawalOfSuspension;
